(function () {
  function setup(row) {
    if (row.dataset.pgrowInit) return;
    row.dataset.pgrowInit = '1';
    var track = row.querySelector('[data-pgrow-track]');
    if (!track) return;
    var items = track.children;
    var dots = row.querySelector('[data-pgrow-dots]');
    var nav = document.querySelector('[data-pgrow-nav="' + row.id + '"]');
    var prev = nav ? nav.querySelector('[data-dir="-1"]') : null;
    var next = nav ? nav.querySelector('[data-dir="1"]') : null;

    function step() {
      var first = items[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function pageIndex() {
      return Math.round(track.scrollLeft / step());
    }

    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var n = items.length;
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var d = document.createElement('i');
        dots.appendChild(d);
      }
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots && dots.children.length) {
        var idx = Math.min(pageIndex(), dots.children.length - 1);
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].classList.toggle('is-on', i === idx);
        }
      }
    }

    function go(dir) {
      var perView = Math.max(1, Math.floor(track.clientWidth / step()));
      track.scrollBy({ left: dir * step() * perView, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    buildDots();
    sync();
  }

  function init() {
    document.querySelectorAll('[data-pgrow]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
